var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KOptionalText',{attrs:{"text":_vm.date ? _vm.$formatRelative(_vm.ceilingDate, { now: _vm.now }) : ''}})
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }